module.exports = __webpack_public_path__ + "static/media/clicked.a25d0086.svg";